import PropTypes from 'prop-types'

const MarketQuartile = PropTypes.shape({
  id: PropTypes.string,
  listPrice: PropTypes.shape({
    median: PropTypes.string,
    min: PropTypes.string
  }),
  marketIndex: PropTypes.string,
  maxPrice: PropTypes.number,
  minPrice: PropTypes.number,
  quartile: PropTypes.number,
  reportedOn: PropTypes.string,
  residenceType: PropTypes.string,
  timelines: PropTypes.shape({
    prepare: PropTypes.number,
    search: PropTypes.number,
    close: PropTypes.number,
    total: PropTypes.number
  }),
  trends: PropTypes.shape({
    baths: PropTypes.string,
    beds: PropTypes.string,
    daysOnMarket: PropTypes.string,
    forSale: PropTypes.string,
    sqftTotal: PropTypes.string
  }),
  type: PropTypes.oneOf(['market-quartiles']),
  week: PropTypes.number
})

export default MarketQuartile
